import Vue from 'vue'
import store from './store/'
import ElementUI from 'element-ui'
import './assets/css/style.scss'
import router from './router/'
import Config from './config/app'
import {isLogin,getUserInfo} from './utils/dataStorage'
import '@/utils/v-auth.js'
import {setKeyMap} from '@/utils/setKeyMap.js'
import './components.js'

import App from './App.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import directives from './directives'

Vue.prototype.$Cfg = Config;
Vue.prototype.$Map = setKeyMap;


Vue.use(ElementUI)
Vue.use(directives)

router.beforeEach((to, from, next) => {
  if (!isLogin() && to.path != '/login' && to.path != '/forget_password') {
    window.document.title = to.meta.title?to.meta.title+'-'+Config.siteName:Config.siteName;
    next({path: '/login'});
  } else {

    if(to.meta.isAdmin && getUserInfo().location == 2){//如果跳到机构列表并且是在机构后台
      window.document.title = to.meta.title?to.meta.title+'-'+Config.siteName:Config.siteName;
      next({path: '/'});
    }else {
      window.document.title = to.meta.title?to.meta.title+'-'+Config.siteName:Config.siteName;
      next();
    }
  }
});



new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});

store.commit("initMenu");//刷新页面初始化菜单
